import "./CaseStudiesSuccessStories.module.css";
import Header from "@/reusable_sections/Header";
import Casestudyhero from "./sections/Casestudyhero";
import Casestudygallery from "./sections/Casestudygallery";
import Impact from "./sections/Impact";
import Metrics from "./sections/Metrics";
import PerformanceComparison from "./sections/PerformanceComparison";
import RevenueFaq from "./sections/RevenueFaq";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function CaseStudiesSuccessStoriesPage() {
  return <div>
      <Header />
      <Casestudyhero />
      <Casestudygallery />
      <Impact />
      <Metrics />
      <PerformanceComparison />
      <RevenueFaq />
      <Services />
      <Footer />
    </div>;
}